import { Image } from '@chakra-ui/image'
import { Flex, Text } from '@chakra-ui/layout'
import { formatPrice } from '../../../../../utils/formatPrice'
import { useMarkup } from '../../contexts/MarkupProvider'
import { Infos } from './Infos'
const imgLoading = '../../../../images/loading-blue.gif'

export function Total() {
  const {
    loading,
    summary,
    summaryValorItems,
    data,
    calcIcmsSt,
    custoTotalSummary,
  } = useMarkup()

  const summaryDestacado = data?.reduce((acc, item) => {
    const { destacado_nota } = item

    const destacadoNota = parseFloat(destacado_nota) || 0

    return acc + destacadoNota
  }, 0)

  const valorTotalPedidos = summaryValorItems.precoVenda + summaryDestacado

  const outrosLucros =
    summary?.lucroSobreFrete +
    summary?.lucroCondicaoPagamento +
    summary?.jurosPagamentoAtrasado +
    summary?.sobraInnovation

  const lucroBrutoTot = summary?.lucroBruto + outrosLucros

  const porcentagem = (lucroBrutoTot / custoTotalSummary) * 100

  return (
    <Flex flex={1} w="full" flexDirection={'column'}>
      <Flex>
        <Infos label="Custo total" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(custoTotalSummary) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(custoTotalSummary)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos
          label="Valor venda de Itens (Preço base)"
          bg="#1A8AB6"
          width="20rem"
        />
        <Infos
          label={
            isNaN(summaryValorItems?.precoBase) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(summaryValorItems?.precoBase)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos label="Preço base - Custo total" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(summaryValorItems?.precoBase - custoTotalSummary) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(summaryValorItems?.precoBase - custoTotalSummary)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos
          label="Valor venda dos Itens (Preço venda)"
          bg="#1A8AB6"
          width="20rem"
        />
        <Infos
          label={
            isNaN(summaryValorItems?.precoVenda) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(summaryValorItems?.precoVenda)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos label="Valor ST (Destacado Nota)" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(calcIcmsSt) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(calcIcmsSt)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos
          label="Valor frete cliente (Destacado nota)"
          bg="#1A8AB6"
          width="20rem"
        />
        <Infos
          label={
            isNaN(summaryDestacado) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(summaryDestacado)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos label="Valor total pedidos" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(valorTotalPedidos) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(valorTotalPedidos)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>

      <Flex>
        <Infos label="Lucro bruto" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(lucroBrutoTot) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              formatPrice(lucroBrutoTot)
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
      <Flex>
        <Infos label="Porcentagem" bg="#1A8AB6" width="20rem" />
        <Infos
          label={
            isNaN(custoTotalSummary) ? (
              <Image src={imgLoading} width="20px" />
            ) : loading ? (
              <Image src={imgLoading} width="20px" />
            ) : (
              <Text color="#1A8AB6" fontWeight="bold" fontSize="1.1rem">
                {parseFloat(porcentagem).toFixed(2)}%
              </Text>
            )
          }
          bg="#ebebeb"
          color="#333"
        />
      </Flex>
    </Flex>
  )
}
